export default [
  {
    path: '/home',
    name: 'home',
    meta: { title: '首页', auth: true, keepAlive: true, deepth: 1, color: '#FD6404' },
    component: () => import('../../views/home/index')
  },
  {
    path: '/search',
    name: 'search',
    meta: { title: '搜索岗位', auth: true, keepAlive: true, deepth: 1.1, color: '#FD6404' },
    component: () => import('../../views/search')
  }
];
